<template lang="html">
  <error-page-layout
    color-type="error"
    error-type="Erro 500"
    first-message="Ocorreu um erro inesperado em nosso servidor."
    focus-message="protocolo de atendimento:"
    icon="cancel"
    image-name="500.png"
    second-message="Acompanhe a resolução desse problema com o "
    title="Algo deu errado"
    under-message="0ZOL7893754"
  >
    <div slot="buttons">
      <v-btn color="orange" dark text>Voltar para a home</v-btn>
      <v-btn color="orange" dark text>Acompanhar chamado</v-btn>
    </div>
  </error-page-layout>
</template>

<script>
import ErrorPageLayout from '@/components/ErrorPageLayout.vue'
export default {
  components: {
    ErrorPageLayout,
  },
}
</script>
